import * as Url from "../Service/Url";
import * as Services from "../Service/Service";

export const GetEmpowerxRFPById = async (id) => {
  let res = await Services.GET(Url.GETEMPOWERXRFP + id);
  return res;
};

export const GetRfpSurveyAnswers = async (rfpId, surveyId) => {
  let res = await Services.GET(
    `${Url.GETRFPSURVEYANSWERS}rfpId=${rfpId}&surveyId=${surveyId}`
  );
  return res;
};

export const RfpSurveyCreateUpdate = async (payload) => {
  let res = await Services.POST(Url.RFPSURVEYCREATEUPDATE, payload);
  return res;
};

export const SubmitRfpSurvey = async (rfpId, surveyId, respName) => {
  let res = await Services.POST(
    `${Url.SUBMITRFPSURVEY}rfpId=${rfpId}&surveyId=${surveyId}&respondentName=${respName}`,
    ""
  );
  return res;
};

export const DeclineRfpSurvey = async (rfpId, surveyId,declineBy,declineDate) => {
  let res = await Services.POST(
    `${Url.DECLINERFPSURVEY}rfpId=${rfpId}&surveyId=${surveyId}&declineBy=${declineBy}&declineDate=${declineDate}`,
    ""
  );
  return res;
};

export const AcceptRfpSurvey = async (rfpId, surveyId) => {
  let res = await Services.POST(
    `${Url.ACCEPTRFPSURVEY}rfpId=${rfpId}&surveyId=${surveyId}`,
    ""
  );
  return res;
};

export const RfpSurveyUploadFilesToImport = async (
  payload,
  spDrugListFile,
  bidRespFile, 
  addSupportFile1,
  addSupportFile2,
  addSupportFile3,
  rebateCreditExclusiveFile,
  rebateCreditAdjustmentFile,
  IsExcludeProduct,
  IsAdjustRebate
) => {
  let { RfpId, QuestionnaireId } = payload;
  const token = localStorage.getItem("token");
  const formData = new FormData();
  formData.append("specialtyDrugListFile", spDrugListFile);
  formData.append("bidderResponseFile", bidRespFile);
  formData.append("addtionalSupportingFile1", addSupportFile1);
  formData.append("addtionalSupportingFile2", addSupportFile2);
  formData.append("addtionalSupportingFile3", addSupportFile3);
  formData.append("rebateCreditExclusiveFile",rebateCreditExclusiveFile);
  formData.append("rebateCreditAdjustmentFile",rebateCreditAdjustmentFile)

  let res = await Services.POSTFORMDATA(
    `${Url.UPLOADFILESTOIMPORTRFPSURVEY}RfpId=${RfpId}&QuestionnaireId=${QuestionnaireId}&IsExcludeProduct=${IsExcludeProduct}&IsAdjustRebate=${IsAdjustRebate}`,
    formData,
    token
  )
  return res;
};

export const CheckRFPSurveyDatainsertintoSnowflake = async (TrackingId) => {
  let res = await Services.GET(
    `${Url.CHECKRFPSURVEYDATAINSERTINTOSNOWFLAKE}TrackingId=${TrackingId}`,
  );
  return res;
};

export const GetHolidayDates = async (date) => {
  let res = await Services.GET(
    `${Url.GETHOLIDAYDATES}inputdate=${date}`
  );
  return res;
};

export const GetPresignedURL = async (RfpId,FileName) => {
  let res = await Services.GET(
    `${Url.GETPRESIGNEDURL}RfpId=${RfpId}&FileName=${FileName}`
  );
  return res;
};

export const GetPresignedUrlofSupportingFile = async (FileName, fileType) => {
  let res = await Services.GET(
    `${Url.GETPRESIGNEDURLOFSUPPORTINGFILE}FileName=${FileName}&fileType=${fileType}`
  );
  return res;
};


export const GetVendorPricingValue = async (RfpId,QuestionnaireId) => {
  let res = await Services.GET(
    `${Url.GETVENDORPRICINGVALUE}RfpId=${RfpId}&QuestionnaireId=${QuestionnaireId}`
  );
  return res;
};

export const SaveRfpSummary = async (payload) => {
  let res = await Services.POST(Url.SAVERFPSUMMARY, payload);
  return res;
};
